"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette, zIndex = _a.zIndex;
    return ({
        root: {
            position: 'absolute',
            zIndex: zIndex.drawer + 1,
            color: palette.common.white
        }
    });
});
exports.default = useStyles;
